import {Toast, ToastSkin} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React, {useState} from 'react'
import {Plan} from '../plan'
import s from './desktop.scss'
import {DesktopProps} from './interfaces'
import {Sidebar} from './sidebar'

export const Desktop = ({
  onPlaceClick,
  onRemoveClick,
  onCheckoutClick,
  showAccessibilityMode,
  selectSeatForDescription,
}: DesktopProps) => {
  const {t} = useTranslation()
  const [forcedPopoverPlanPlaceId, setForcedPopoverPlanPlaceId] = useState(null as string)
  const [accessibilityToast, setAccessibilityToast] = useState(false)

  return (
    <div className={s.container}>
      <Sidebar
        onRemoveClick={onRemoveClick}
        onCheckoutClick={onCheckoutClick}
        setForcedPopoverPlanPlaceId={setForcedPopoverPlanPlaceId}
        selectSeatForDescription={selectSeatForDescription}
        setAccessibilityToast={setAccessibilityToast}
      />
      <div className={s.planContainer}>
        {showAccessibilityMode && accessibilityToast ? (
          <Toast
            className={s.toast}
            skin={ToastSkin.status}
            shouldShowCloseButton
            onClose={() => setAccessibilityToast(false)}
          >
            {t('seatings_accessibility_toast')}
          </Toast>
        ) : null}
        <Plan
          onPlaceClick={onPlaceClick}
          forcedPopoverPlanPlaceId={forcedPopoverPlanPlaceId}
          setAccessibilityToast={setAccessibilityToast}
        />
      </div>
    </div>
  )
}
